import Vue from 'vue'

const actions = {
  loadMarkets ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('/markets.json').then((response) => {
        commit('SET_MARKETS', { markets: response.data })

        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}

export default actions
